import React, { FC, useEffect, useState } from 'react';
import {
	Dialog,
	DialogTitle,
	FormControl,
	FormControlLabel,
	IconButton,
	InputAdornment,
	InputLabel,
	MenuItem,
	Radio,
	RadioGroup,
	Select,
	SelectChangeEvent,
} from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import {
	testSip,
	changeSip,
	changePassword,
	changeDisplayName,
	changeTariffUser,
	getProfile,
} from '../../service/UsersService';
import { setErrorApp, setInfoApp } from '../../store/reducers/InfoSlice';
import styles from './profileForm.module.css';
import { LoadingButton } from '@mui/lab';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { fetchProfile } from '../../service/ProfileServiceThunk';
import { returnTasks } from '../../service/TasksService';
import { TYPE_SERVICE } from '../../utils/const';
import ProfileFormAddNewSip from './ProfileFormAddNewSip/ProfileFormAddNewSip';
import { SipAccountBlock } from './SipAccountBlock';
import { IAcc } from '../../models/IProfile';

interface ProfileFormProps {
	open: boolean;
	handleClose: () => void;
}
const ProfileForm: FC<ProfileFormProps> = ({ open, handleClose }) => {
	const { profile } = useAppSelector((state) => state.profileReducer);
	const serverSipValue: string = profile?.server_sip_getter
		? profile?.server_sip_getter
		: 'multifon.ru';

	const linesInit: number = profile?.lines_getter
		? Number(profile?.lines_getter)
		: 2;

	const initTariff = () => {
		if (profile?.tariff) return profile.tariff;
		return '';
	};

	const audioCodecInit = () => {
		if (profile?.audio_codec_getter) return profile?.audio_codec_getter;
		return serverSip.includes('mangosip') ? 'PCMA' : 'PCMU';
	};
	
	const displayNameValue: string =
		typeof (profile?.display_name) === 'string' ? profile?.display_name : '';

	const [loginSip, setLogin] = useState<string>(profile?.phone_getter ?? '');
	const [passSip, setPass] = useState<string>(profile?.phone_pass_getter ?? '');
	const [serverSip, setServer] = useState<string>(serverSipValue);
	const [lineSip, setLine] = useState<number>(linesInit);
	const [loading, setLoading] = useState<boolean>(false);
	const [showPassword, setShowPassword] = useState<boolean>(false);
	const [showPasswordUser, setShowPasswordUser] = useState<boolean>(false);
	const [passUser, setPassUser] = useState<string>('');
	const [passUserConfirm, setPassUserConfirm] = useState<string>('');
	const [displayName, setDisplayName] = useState<string>('');
	const [selectTariff, setSelectTariff] = useState<boolean>(false);
	const [tariff, changeTariff] = useState<string>(initTariff);
	const [accs, setAccs] = useState<IAcc[]>([]);
	const [editAcc, setEditAcc] = useState<IAcc | undefined>(undefined);
	const [openAddNewSip, setOpenAddNewSip] = useState<boolean>(false);
	const [audioCodec, setAudioCodec] = useState<string>(audioCodecInit);
	
	const handleOpen = async () => {
		const task = await checkTask(
			'Для добавления дополнительного аккаунта, необходимо выключить прием показаний счетчиков'
		);
		if (task) return;
		setOpenAddNewSip(true)
	};
	const handleCloseAddNewSip = () => setOpenAddNewSip(false);

	useEffect(() => {
		if (
			profile &&
			'balance_getter_advanced' in profile &&
			'balance_getter_basic' in profile
		) {
			setSelectTariff(true);
		}
		changeTariff(initTariff)
	}, [profile]);

	useEffect(() => {
		try {
			if (!profile || !profile.additional_accounts_getter) {
				return;
			}

			const data = JSON.parse(profile.additional_accounts_getter);
			setAccs(data);

		} catch (e) {
			// TODO: error
		}
	}, [profile]);


	useEffect(() => {
		setServer(serverSipValue);
		setLine(linesInit);
		setLogin(profile?.phone_getter ?? '');
		setPass(profile?.phone_pass_getter ?? '');
		setDisplayName(displayNameValue);
		setAudioCodec(audioCodecInit);
	}, [profile, open])


	const resetToDefault = () => {
		setServer(serverSipValue);
		setLine(linesInit);
	};

	const checkTask = async (textError: string) => {
		const userTasks = await returnTasks();
		if (userTasks.error) {
			return dispatch(
				setErrorApp({
					isErrorApp: true,
					errorApp: 'Произошла ошибка при проверке запущенных задач',
				})
			);
		} else {
			const { data } = userTasks.data.data;
			if (data.length > 0) {
				for (const itemTask of data) {
					if (itemTask.nameFile.includes(TYPE_SERVICE)) {
						return dispatch(
							setErrorApp({
								isErrorApp: true,
								errorApp: textError,
							})
						);
					}
				}
			}
		}
	};

	const handleCloseMainDialog = () => {
		handleClose();
		resetToDefault();
	};

	const handleClickShowPassword = () => {
		setShowPassword(!showPassword);
	};

	const handleMouseDownPassword = (event: { preventDefault: () => void }) => {
		event.preventDefault();
	};

	const handleClickShowPasswordUser = () => {
		setShowPasswordUser(!showPasswordUser);
	};

	const handleMouseDownPasswordUser = (event: {
		preventDefault: () => void,
	}) => {
		event.preventDefault();
	};

	const dispatch = useAppDispatch();

	const handleChange = (
		evt: React.ChangeEvent<HTMLInputElement> | SelectChangeEvent<any>,
		type: string
	) => {
		if (type === 'login') {
			setLogin(evt.target.value);
		} else if (type === 'password') {
			setPass(evt.target.value);
		} else if (type === 'server') {
			if (/^[0-9a-z.:]+$/gi.test(evt.target.value) || evt.target.value === '') {
				setServer(evt.target.value);
				setAudioCodec(evt.target.value.includes('mangosip') ? 'PCMA' : 'PCMU');
			}
		} else if (type === 'lines') {
			if (
				(/^\d+$/.test(evt.target.value) && Number(evt.target.value) <= 60) ||
				evt.target.value === ''
			) {
				setLine(Number(evt.target.value));
			}
		} else if (type === 'passUser') {
			setPassUser(evt.target.value);
		} else if (type === 'passUserConfirm') {
			setPassUserConfirm(evt.target.value);
		} else if (type === 'displayName') {
			setDisplayName(evt.target.value);
		} else if (type === 'audioCodec') {
			setAudioCodec(evt.target.value);
		}
	};

	const onSaveName = async () => {
		const response = await changeDisplayName(displayName);
		if (response.error) {
			dispatch(
				setErrorApp({
					isErrorApp: true,
					errorApp: `Произошла ошибка при смене имени пользователя`,
				})
			);
		} else {
			dispatch(
				setInfoApp({
					isInfoApp: true,
					infoApp: `Имя пользователя изменено`,
				})
			);
			dispatch(fetchProfile());
			handleCloseMainDialog();
		}
	};

	const onTestSip = async () => {
		setLoading(true);
		const response = await testSip({
			lineSip: String(lineSip),
			loginSip,
			passSip,
			serverSip,
		});

		if (response.error) {
			setLoading(false);
			dispatch(
				setErrorApp({
					isErrorApp: true,
					errorApp: 'Произошла ошибка при проверке статуса сип',
				})
			);
		} else {
			setLoading(false);
			const { statusSip, timeUpdateSip } = response.data.data;
			let message: string;
			if (statusSip === null || timeUpdateSip === null) {
				message = 'Произошли проблемы обратитесь в техподдержку';
			} else {
				message = `Статус сип-соединения: "${statusSip}", время проверки: "${timeUpdateSip}"`;
			}
			dispatch(setInfoApp({ isInfoApp: true, infoApp: message }));
		}
	};

	const onChangeSip = async () => {
		const profilePromise = await getProfile();
		if (profilePromise) {
			const user = profilePromise.data.data;
			if (
				user?.payment_type.includes('calls') &&
				user?.phone_autocall === loginSip &&
				user?.server_sip_autocall === serverSip
			) {
				return dispatch(
					setErrorApp({
						isErrorApp: true,
						errorApp:
							'Данное сип-соединение уже используется в обзвоне должников',
					})
				);
			} else if (
				user?.payment_type_shop === 'shop' &&
				user?.phone_shop === loginSip &&
				user?.server_sip_shop === serverSip
			) {
				return dispatch(
					setErrorApp({
						isErrorApp: true,
						errorApp:
							'Данное сип-соединение уже используется в подтверждении заказов',
					})
				);
			}
		}
		const task = await checkTask(
			'Для изменения сип подключения, необходимо выключить прием показаний счетчиков'
		);
		if (task) return;
		if ((loginSip.length === 0 || (!loginSip.trim())) ||
			(passSip.length === 0 || (!passSip.trim())) ||
			(serverSip.length === 0) || (lineSip === 0)) {
			dispatch(
				setErrorApp({
					isErrorApp: true,
					errorApp: 'Необходимо заполнить обязательные поля',
				})
			);
			return;
		}
		const response = await changeSip({
			lineSip: String(lineSip),
			loginSip,
			passSip,
			serverSip,
			audioCodec
		});
		if (response.error) {
			dispatch(
				setErrorApp({
					isErrorApp: true,
					errorApp: 'При обновлении профиля возникла ошибка',
				})
			);
		} else {
			dispatch(
				setInfoApp({ isInfoApp: true, infoApp: 'SIP профиль обновлен' })
			);
			dispatch(fetchProfile());
			handleCloseMainDialog();
		}
	};

	const onChangePassword = async () => {
		if (passUser != passUserConfirm) {
			return dispatch(
				setErrorApp({
					isErrorApp: true,
					errorApp: `Пароли не совпадают`,
				})
			);
		} else {
			const response = await changePassword(passUser);
			if (response.error) {
				const { msg } = response.error.response.data;
				const textError = msg || 'При смене пароля произошла ошибка';
				dispatch(
					setErrorApp({
						isErrorApp: true,
						errorApp: textError,
					})
				);
			} else {
				dispatch(setInfoApp({ isInfoApp: true, infoApp: 'Профиль обновлен' }));
				dispatch(fetchProfile());
				handleCloseMainDialog();
			}
		}
	};

	const handleChangeTariff = (evt: React.ChangeEvent<HTMLInputElement>) => {
		changeTariff(evt.target.value);
	};

	const onSaveTariff = async () => {
		const task = await checkTask(
			'Для смены тарифа, необходимо выключить прием показаний счетчиков'
		);
		if (task) return changeTariff(initTariff);
		const response = await changeTariffUser(tariff);
		if (response.error) {
			dispatch(
				setErrorApp({
					isErrorApp: true,
					errorApp: `Произошла ошибка при смене тарифа`,
				})
			);
		} else {
			dispatch(
				setInfoApp({
					isInfoApp: true,
					infoApp: `Тариф успешно изменен`,
				})
			);
			dispatch(fetchProfile());
			handleCloseMainDialog();
		}
	};

	return (
		<Dialog scroll={'body'} open={open} onClose={handleCloseMainDialog}>
			<DialogTitle className={styles.profile_label}>
				Настройки подключения
				<button onClick={handleCloseMainDialog} className={styles.close_modal}>
					×
				</button>
			</DialogTitle>
			<div className={styles.container}>
				<div className={styles.wrapper_for_sip_options}>
					<DialogContent className={styles.dialog_content}>
						<DialogContentText className={styles.label_for_wrapper_sip}>
							SIP аккаунт
						</DialogContentText>
						<TextField
							margin="dense"
							id="login_sip"
							label="Логин sip"
							fullWidth
							variant="standard"
							defaultValue={profile?.phone_getter}
							onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
								handleChange(evt, 'login')
							}
							required
						/>
						<TextField
							margin="dense"
							id="outlined-adornment-password-sip"
							fullWidth
							variant="standard"
							className={styles.password_input}
							type={showPassword ? 'text' : 'password'}
							defaultValue={profile?.phone_pass_getter}
							onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
								handleChange(evt, 'password')
							}
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">
										<IconButton
											aria-label="toggle password visibility"
											onClick={handleClickShowPassword}
											onMouseDown={handleMouseDownPassword}
											edge="end"
										>
											{showPassword ? <VisibilityOff /> : <Visibility />}
										</IconButton>
									</InputAdornment>
								),
							}}
							label="Пароль sip"
							required
						/>
						<TextField
							margin="dense"
							id="server_sip"
							label="Адрес sip сервера"
							fullWidth
							variant="standard"
							value={serverSip}
							onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
								handleChange(evt, 'server')
							}
							required
						/>
						<TextField
							inputProps={{ inputMode: 'numeric', min: 1, max: 60 }}
							margin="dense"
							id="line_sip"
							label="Количество линий"
							fullWidth
							variant="standard"
							value={lineSip}
							onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
								handleChange(evt, 'lines')
							}
							required
						/>

						<FormControl variant="standard" sx={{ m: '8px 0px', minWidth: 510 }}>
							<InputLabel id="demo-simple-select-standard-label">Выбор аудио кодека</InputLabel>
							<Select
								labelId="demo-simple-select-standard-label"
								id="demo-simple-select-standard"
								value={audioCodec}
								onChange={(evt: SelectChangeEvent<any>) =>
									handleChange(evt, 'audioCodec')}
							>
								<MenuItem value={'PCMA'}>G.711 a (PCMA)</MenuItem>
								<MenuItem value={'PCMU'}>G.711 u (PCMU)</MenuItem>
							</Select>
						</FormControl>
					</DialogContent>
					<DialogActions className={styles.wrapper_for_buttons}>
						<Button
							disabled={
								loginSip === (profile?.phone_getter ?? '') &&
								passSip === (profile?.phone_pass_getter ?? '') &&
								serverSip === serverSipValue &&
								lineSip === linesInit &&
								audioCodec === audioCodecInit()
							}
							onClick={onChangeSip}
						>
							Сохранить
						</Button>
						<LoadingButton
							disabled={
								loginSip.length === 0 ||
								(!loginSip.trim()) ||
								passSip.length === 0 ||
								(!passSip.trim()) ||
								serverSip.length === 0 ||
								(!serverSip.trim()) ||
								Number(lineSip) > 60 ||
								Number(lineSip) < 1
							}
							loading={loading}
							onClick={onTestSip}
						>
							Проверка sip-соединения
						</LoadingButton>
					</DialogActions>
				</div>
				<div className={styles.wrapper_for_sip_options_new_sip}>
					<DialogContent className={styles.dialog_content}>
						<DialogContentText className={styles.label_for_wrapper_sip}>
							Дополнительные SIP аккаунты
						</DialogContentText>
						<SipAccountBlock
							accs={accs}
							handleOpenAddNewSip={(item: IAcc) => {
								handleOpen();
								setEditAcc(item);
							}}
						/>
					</DialogContent>
					<DialogActions className={styles.wrapper_for_buttons_key}>
						<Button
							onClick={handleOpen}
						>
							Добавить
						</Button>
					</DialogActions>
				</div>
				{selectTariff ? (
					<div className={styles.wrapper_for_sip_options}>
						<DialogContent className={styles.dialog_content}>
							<DialogContentText className={styles.label_for_tariff}>
								Изменение тарифа пользователя
							</DialogContentText>
							<FormControl className={styles.form_control_tariff}>
								<RadioGroup
									row
									aria-labelledby="value_tariff"
									name="row-radio"
									value={tariff}
									className={`${styles.tariff_control} change-radio-group`}
									onChange={(evt) => handleChangeTariff(evt)}
								>
									<div>
										<FormControlLabel
											value="basic"
											control={<Radio size="small" />}
											label="Базовый"
										/>
									</div>
									<div>
										<FormControlLabel
											value="advanced"
											control={<Radio size="small" />}
											label="Расширенный"
										/>
									</div>
								</RadioGroup>
							</FormControl>
						</DialogContent>
						<DialogActions className={styles.wrapper_for_buttons_key}>
							<Button
								// disabled={displayName.length === 0 || displayName.length >= 50}
								onClick={onSaveTariff}
							>
								Изменить тариф
							</Button>
						</DialogActions>
					</div>
				) : null}
				<div className={styles.wrapper_for_sip_options}>
					<DialogContent className={styles.dialog_content}>
						<DialogContentText className={styles.label_for_wrapper_sip}>
							Изменение имени пользователя
						</DialogContentText>
						<TextField
							margin="dense"
							id="display_name"
							label="Имя пользователя"
							fullWidth
							variant="standard"
							defaultValue={displayNameValue}
							onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
								handleChange(evt, 'displayName')
							}
						/>
					</DialogContent>
					<DialogActions className={styles.wrapper_for_buttons_key}>
						<Button
							disabled={
								displayName.length === 0 ||
								displayName.length >= 50 ||
								(!displayName.trim()) ||
								displayName === displayNameValue
							}
							onClick={onSaveName}
						>
							Сохранить
						</Button>
					</DialogActions>
				</div>
				<div className={styles.wrapper_for_sip_options}>
					<DialogContent className={styles.dialog_content}>
						<DialogContentText className={styles.label_for_wrapper_sip}>
							Изменение пароля
						</DialogContentText>
						<TextField
							margin="dense"
							id="outlined-adornment-password"
							fullWidth
							variant="standard"
							className={styles.password_input}
							type={showPasswordUser ? 'text' : 'password'}
							// defaultValue={profile!.phone_pass}
							onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
								handleChange(evt, 'passUser')
							}
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">
										<IconButton
											aria-label="toggle password visibility"
											onClick={handleClickShowPasswordUser}
											onMouseDown={handleMouseDownPasswordUser}
											edge="end"
										>
											{showPasswordUser ? <VisibilityOff /> : <Visibility />}
										</IconButton>
									</InputAdornment>
								),
							}}
							label="Новый пароль"
							required
						/>
						<TextField
							margin="dense"
							id="outlined-adornment-password-confirm"
							fullWidth
							variant="standard"
							className={styles.password_input}
							type={showPasswordUser ? 'text' : 'password'}
							// defaultValue={profile!.phone_pass}
							onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
								handleChange(evt, 'passUserConfirm')
							}
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">
										<IconButton
											aria-label="toggle password visibility"
											onClick={handleClickShowPasswordUser}
											onMouseDown={handleMouseDownPasswordUser}
											edge="end"
										>
											{showPasswordUser ? <VisibilityOff /> : <Visibility />}
										</IconButton>
									</InputAdornment>
								),
							}}
							label="Подтверждение"
							required
						/>
					</DialogContent>
					<DialogActions className={styles.wrapper_for_buttons_key}>
						<Button
							disabled={passUser.length === 0 || passUserConfirm.length === 0}
							onClick={onChangePassword}
						>
							Сохранить
						</Button>
					</DialogActions>
				</div>
			</div>
			<ProfileFormAddNewSip
				openAddNewSip={openAddNewSip}
				handleCloseAddNewSip={(setId) => {
					handleCloseAddNewSip();
					setEditAcc(setId);
				}}
				acc={editAcc}
			/>
		</Dialog>
	);
};

export default ProfileForm;
